import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Button from '../Button';
import { StepCardTag, StepCardHeading, StepCardDescription, StepCardButtonContainer } from "./styles";

const StepCard = ({ number, heading, description, buttonDescription, linkTo }) => (
  <StepCardTag number={number}>
    <StepCardHeading>{heading}</StepCardHeading>
    <StepCardDescription>{description}</StepCardDescription>
    <StepCardButtonContainer>
      <Link href={linkTo || '/'}>
        <a>
          <Button htmlType="button" theme={buttonDescription.type}>
            {buttonDescription.text}
          </Button>
        </a>
      </Link>
    </StepCardButtonContainer>
  </StepCardTag>
);

StepCard.propTypes = {
  number: PropTypes.number.isRequired,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonDescription: PropTypes.shape({ type: PropTypes.string.isRequired, text: PropTypes.string.isRequired }).isRequired,
  linkTo: PropTypes.string,
};

export default StepCard;
